import { useEffect, useState, useCallback } from "react";

const PREFIX = "kvh_";

export function readLS(key, fallback) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function useLocalStorage(key, initial) {
  const [value, setValue] = useState(() => readLS(key, initial));
  useEffect(() => {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
    } catch {
      /* yoksay */
    }
  }, [key, value]);
  const update = useCallback((v) => setValue(v), []);
  return [value, update];
}

export const fmt = (n, d = 2) =>
  Number.isFinite(n) ? n.toLocaleString("tr-TR", { maximumFractionDigits: d }) : "–";
